/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Box, Typography, Divider, TextField, Button, useTheme } from "@mui/material";
import StudentForm from "../collectDataNotification/studentform";
import NotificationModal from "../../notificationModal/notificationModal";
import ChooseBylaw from "../chooseBylaw";
import Cookies from 'js-cookie'; 
import BylawBox from "../bylawbox";
import DataList, { ICourse } from "../../inputForm/courseDataList";
import axios, { AxiosError } from "axios";

interface IReportBugNotification {
  onClose: () => void;
  bylaw: string;
}

const ReportBugNotification: React.FC<IReportBugNotification> = (props: IReportBugNotification) => {

  const { bylaw, onClose } = props;

  const [ bugDetails, setBugDetails ] = useState('');
  const [ buggedCourse, setBuggedCourse ] = useState('');
  const [ buggedBylaw, setBuggedBylaw ] = useState('New');
  const [ isReported, setIsReported ] = useState<boolean>(false);

  const theme = useTheme();

  const onChooseCourse = (course: ICourse) => {
    setBuggedCourse(`${course.code}: ${course.name}`)
  }

  const onClickReport = async() => {
    try {
      const requestBody = {
        email: "marwan62x@gmail.com",
        subject: "CHS Absense Tool Bug",
        text: `Course: ${buggedCourse}\nBylaw: ${buggedBylaw}\nDetails: ${bugDetails}`
      };
      const respone = await axios.post('https://credithub.onrender.com/api/contact/send-mail', requestBody);
    } catch (error: any) {
      console.log(error.response?.data);
    }
    setIsReported(true);
    setTimeout(()=>{onClose()},750)
  }

  const style: React.CSSProperties = {
    fontSize: '16px',
    fontWeight: '700', 
  }


  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
        borderRadius: '10px',
        minHeight: '80%',
        overflowY:'auto',
        outline: 0,
        boxShadow: 24,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
        WebkitTransition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',

        p: 4,
        '@media screen and (max-width: 768px)': { width: '80%', paddingBottom: '60px'}
      }}>
      <Typography 
        sx={{  
          fontSize:'50px',
          fontWeight:'700',
          marginBottom: '0px',
          paddingBottom: '0px',            
        }}
      >
        Report a Bug
      </Typography>
      <Box
        sx={{
          display:'flex',
          flexDirection: 'column', 
          boxSizing: 'border-box',
          width: '100%', 
          height:"400px",
        }}>

        <Divider sx={{marginBottom:'10px'}}/>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
          <Typography 
            sx={{
              fontWeight: '700', 
              fontSize: '18px', 
            }}>  
            If the bug is related to a particular course, choose the byalw and the course:
          </Typography>

          <Box sx={{display: 'flex', alignItems: 'center', gap: '25px'}}>
            <Typography sx={{minWidth: '55px'}}> Bylaw: </Typography>
            <BylawBox
              onClick={() => setBuggedBylaw('New')}
              active
              sx={{ 
                flexDirection: 'row', 
                background: buggedBylaw === 'New' || buggedBylaw === '' ? theme.palette.common.acceptGreen : 'grey', 
                opacity: buggedBylaw === 'New' || buggedBylaw === '' ? 1 : 0.5,
                borderRadius: '4px',
                width: '150px', 
                height: '35px', 
                fontSize: '16px',
                gap: '10px', 
                ':hover': {
                  background: theme.palette.common.acceptGreenHover
                }               
              }}>
              <Typography sx={{style}}> New Bylaw </Typography>
            </BylawBox>

            <BylawBox
              onClick={() => setBuggedBylaw('Old')}
              active
              sx={{ 
                flexDirection: 'row', 
                background: buggedBylaw === 'Old' || buggedBylaw === '' ? theme.palette.common.acceptGreen : 'grey',
                opacity:  buggedBylaw === 'Old' || buggedBylaw === '' ? 1 : 0.5,
                borderRadius: '4px',
                width: '150px', 
                height: '35px', 
                fontSize: '16px',
                gap: '10px',
                ':hover': {
                  background: theme.palette.common.acceptGreenHover
                }
              }}>
              <Typography sx={{style}}> Old Bylaw </Typography>
            </BylawBox>
          </Box>

          <Box 
            sx={{
              display: 'flex', 
              alignItems: 'center', 
              gap: '25px', 
            }}>
            <Typography sx={{minWidth: '55px'}}> Course: </Typography>
            {/* <DataList bylaw={Cookies.get('bylaw') ?? 'New'} department={} onChoose={(course) => onChooseCourse(course)}/> */}
          </Box>
          <Typography 
            sx={{
              fontWeight: '700', 
              fontSize: '18px', 
              marginBottom: '10px'
            }}>  
            Write the bug in details:
          </Typography>
        </Box>
        <TextField
          multiline
          onChange={(e) => setBugDetails(e.target.value)}
          InputProps={{sx:{height: '800px', alignItems: 'flex-start'}}}
          label={'Bug Details...'} 
          InputLabelProps={{
            style: { color: 'black' },
          }}
          sx={{
            height: '295px', 
            marginBottom: '10px',
            ".MuiOutlinedInput-notchedOutline": { border: '1px solid black'},
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{ border: '1px solid black' },
          
          }} 
        />
        <Box sx={{display: 'flex', flexDirection: 'row-reverse', gap: '10px', paddingBottom: '10px'}}>
          <Button 
            onClick={() => onClose()}
            sx={{ 
              background: theme.palette.common.darkBlue, 
              height: '40px', 
              width: '150px', 
              color: 'white', 
              fontSize: 13, 
              fontWeight: 700, 
              ':hover': {background: theme.palette.common.darkBlueHover}
            }}>
            Close
          </Button>
          <Button
            id={'submit-bug'}
            onClick={() => onClickReport()}
            sx={{ 
              background: isReported ? theme.palette.common.acceptGreen : theme.palette.common.bugRed, 
              height: '40px', 
              width: '150px', 
              color: theme.palette.common.white, 
              fontSize: 13, 
              fontWeight: 700, 
              ':hover': {              
                background: isReported ? theme.palette.common.acceptGreenHover : theme.palette.common.bugRedHover, 
              }
            }}>
            { isReported ? 'Reported' : 'Report'  }
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
export default ReportBugNotification;